export const list = {
  realname: {
    name: '姓名',
    key: 'realname',
    check: false
  },
  job_number: {
    name: '工号',
    key: 'job_number',
    sortable: true
  },
  depart_id: {
    name: '所属部门',
    key: 'depart_id'
  },
  job: {
    name: '职位',
    key: 'job'
  },
  resign_time: {
    name: '离职日期',
    key: 'resign_time',
    sortable: true
  },
  phone: {
    name: '电话',
    key: 'phone'
  },
  working_status: {
    name: '状态',
    key: 'working_status'
  },
  email: {
    name: '邮箱',
    key: 'email'
  },
};
